import styled from "@emotion/styled";
import { useDragDrop } from "@ext/navigation/catalog/drag/logic/ModifiedBackend";
import { type CSSProperties, forwardRef, type ReactNode, type RefObject } from "react";
import { DndProvider } from "react-dnd";
import Scrollable from "../ScrollableElement";

interface LeftSidebarProps {
	children: ReactNode;
	shadow?: boolean;
	boxShadowStyles?: { top?: string; bottom?: string };
	sidebarTop?: JSX.Element;
	sidebarBottom?: JSX.Element;
	style?: CSSProperties;
	onContentMouseEnter?: () => void;
	onContentMouseLeave?: () => void;
	className?: string;
}

const LeftSidebar = forwardRef((props: LeftSidebarProps, ref: RefObject<HTMLDivElement>) => {
	const { children, shadow = true, boxShadowStyles, sidebarTop, sidebarBottom, style, className } = props;
	const { onContentMouseEnter, onContentMouseLeave } = props;
	const { backend, options } = useDragDrop();

	return (
		<div className={className} style={style}>
			{sidebarTop}
			<DndProvider backend={backend} options={options}>
				<Scrollable
					boxShadowStyles={boxShadowStyles}
					onMouseEnter={onContentMouseEnter}
					onMouseLeave={onContentMouseLeave}
					ref={ref}
					showTopBottomShadow={shadow}
					style={style}
				>
					{children}
				</Scrollable>
			</DndProvider>
			{sidebarBottom}
		</div>
	);
});

export default styled(LeftSidebar)`
	display: flex;
	width: inherit;
	height: inherit;
	flex-direction: column;
`;
